export default {
  baseStyle: {
    container: {
      borderRadius: "full",
      px: "12px",
    },
  },
};
